import { useT } from "../../../../shared/i18n/i18n";
import { Archive } from "lucide-react";
import type { BoardView } from "../../../../entities/board/model/use-boards";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

type BoardSettingsDialogProps = {
  board: BoardView;
  disabled: boolean;
  onArchive: () => Promise<void>;
  onOpenChange: (open: boolean) => void;
  open: boolean;
};

export function BoardSettingsDialog({
  board,
  disabled,
  onArchive,
  onOpenChange,
  open,
}: BoardSettingsDialogProps) {
  const t = useT();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("board.settings")}</DialogTitle>
          <DialogDescription className="sr-only">Settings for {board.name}</DialogDescription>
        </DialogHeader>
        <h3 className="truncate text-base font-semibold text-foreground">{board.name}</h3>
        <div className="flex items-center justify-between gap-3 rounded-md border border-destructive/20 bg-destructive/5 p-3">
          <div className="min-w-0">
            <p className="text-xs font-medium text-destructive">{t("board.archiveBoard")}</p>
            <p className="text-xs text-muted-foreground">{t("board.archiveBoardHint")}</p>
          </div>
          <Button
            disabled={disabled}
            onClick={() => {
              void onArchive();
            }}
            variant="destructive"
          >
            <Archive data-icon="inline-start" />
            {t("board.archiveBoard")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
